export const Header = ({ text }) => {
  return (
    <section className="bg-[#FEC722] p-4 md:p-8 flex items-center w-full justify-center">
      <div className="text-2xl md:text-4xl text-white text-center">{text}</div>
    </section>
  );
};
